import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Shared brand lockup — the single source of truth for the CadencEZ
 * logo + wordmark. Renders the /logo.png asset sized to match the
 * height of the wordmark text so the pair reads as one unit, followed
 * by the localized brand name.
 *
 * Used in SiteHeader and on every auth page so the mark is byte-for-byte
 * identical everywhere. By default the lockup is a react-router Link to
 * the top page ("/"); pass `to={null}` to render a non-interactive mark.
 */
export function BrandMark({ to = '/' }: { to?: string | null }) {
  const { t } = useTranslation();

  const inner = (
    <>
      <img
        src="/logo.png"
        alt={t('brand.name')}
        className="h-9 w-9 rounded-md object-contain shrink-0"
      />
      <span className="display text-[19px] font-semibold tracking-tight">{t('brand.name')}</span>
    </>
  );

  if (to === null) {
    return <span className="flex items-center gap-2.5">{inner}</span>;
  }

  return (
    <Link to={to} className="flex items-center gap-2.5">
      {inner}
    </Link>
  );
}
